module.exports = __webpack_public_path__ + "static/img/011.4b6d1b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/diy/011.jpg
// module id = w0/L
// module chunks = 15